module.exports = __webpack_public_path__ + "static/media/16.499aa423.jpg";